import(/* webpackMode: "eager" */ "/workspace/build/buildkite/faire/main-frontend-signup/packages/signup/signup/src/app/(app)/error.tsx");
